import {createReducer, on} from '@ngrx/store'
import {przedmiotyStanPoczatkowy} from './przedmioty.stan-poczatkowy';
import {PrzedmiotUbezpieczenia} from './przedmiot.interface';
import {PrzedmiotUbezpieczeniaDTO} from '../../../services/samoobsluga/types/przedmiotUbezpieczeniaDTO.interface';
import {pobierzDaneZgloszeniaSuccess} from '../../../../init/store/init.actions';
import {kliknietoRozpocznijSuccess} from '../../../../samoobsluga/strona-startowa/store/strona-startowa.actions';
import {zapiszStorePoZmianieStanuNaKwotaUkryta} from '../../../../samoobsluga/proces-decyzji/ekran-braku-prezentacji-kwoty-po-kalkulacji/store/ekran-braku-prezentacji-kwoty-po-kalkulacji.actions';
import {kliknietoKalkulujSuccess, kliknietoWyliczPozniejSuccess,} from '../../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/ekran-podsumowania.actions';
import {pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty, pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej} from '../../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/krok-po-kalkulacji/krok-po-kalkulacji.actions';

export const przedmiotyReducer = createReducer(
  przedmiotyStanPoczatkowy,
  on(pobierzDaneZgloszeniaSuccess, kliknietoRozpocznijSuccess,
    kliknietoKalkulujSuccess,
    zapiszStorePoZmianieStanuNaKwotaUkryta, pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej,
    pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty, kliknietoWyliczPozniejSuccess,
    (state, action): any => {
      return ({
        ...state,
        przedmioty: pobierzPrzedmioty(action.przedmioty)
      })
    }),
);

const pobierzPrzedmioty = (przedmioty: PrzedmiotUbezpieczeniaDTO[]) => {
  const przedmiotyDoStore: PrzedmiotUbezpieczenia[] = [];
  przedmioty.forEach(przedmiot => {
    przedmiotyDoStore.push(konwertujPrzedmiotDTOnaPrzedmiot(przedmiot));
  })
  return przedmiotyDoStore;
}

const konwertujPrzedmiotDTOnaPrzedmiot = (przedmiotDTO: PrzedmiotUbezpieczeniaDTO) => {
  const przedmiot = {} as PrzedmiotUbezpieczenia;
  przedmiot.typPrzedmiotu = przedmiotDTO.typPrzedmiotu;
  przedmiot.id = przedmiotDTO.id;
  przedmiot.czyDataRemontuWymagana = przedmiotDTO.zuzycieTechniczne?.czyUwzgledniamy
  przedmiot.czyWybrany = przedmiotDTO.czyWybrany
  przedmiot.kwotaRoszczenia =  przedmiotDTO.kwotaRoszczenia
  return przedmiot;
}
